import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Settings } from '../settings';

@Injectable({providedIn: 'root'})
export class BasicAuthInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with basic auth credentials if available
        let token: any | undefined = Settings.getInstance()?.jwtToken;
        if (token && token != "undefined") {
            request = request.clone({
                setHeaders: { 
                	Bearer: token
                },
                withCredentials: true,
                headers: request.headers.set('X-Requested-With', 'XMLHttpRequest')
            });
        }
        return next.handle(request);
    }
}